import IconRocketship from './component.jsx'
export default IconRocketship
